import yxqnSwitch from './yxqnSwitch.vue'
const yxqnSwitchOp = {
  install: (Vue) => {
    Vue.component('yxqnSwitch', yxqnSwitch)
  }
}
export default yxqnSwitchOp

